
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.771.667c.863 0 1.563.7 1.563 1.562v9.375c0 .863-.7 1.563-1.563 1.563H6.396c-.863 0-1.562-.7-1.562-1.563V2.23c0-.862.7-1.562 1.562-1.562h9.375zM6.396 14.209a2.607 2.607 0 01-2.604-2.604V4.833H2.229c-.862 0-1.562.7-1.562 1.562v9.375c0 .863.7 1.563 1.562 1.563h9.375c.863 0 1.563-.7 1.563-1.563V14.21h-6.77z","fill":"#999"}})])
          )
        }
      }
    